import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=f4dd1c84&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=f4dd1c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dd1c84",
  null
  
)

export default component.exports